import { ENTERPRISE_PARTNER_ID } from '@brighte/enterprise-common/constants';
import {
  AdjustmentsIcon,
  ArrowCircleRightIcon as BrighteArrowCircleRightIcon,
  CheckCircleIcon as BrighteCheckCircleIcon,
  PlusCircleIcon as BrightePlusCircleIcon,
  ExclamationCircleIcon,
  IconProps,
  InformationCircleIcon,
  SortAscendingIcon,
} from '@spark-web/icon';

import { MarketplacePartner } from '~/types/marketplace';

import addFilledIcon from '../../public/icons/add-filled.svg';
import arrowRightFilledIcon from '../../public/icons/arrow-right-filled.svg';
import checkFilledIcon from '../../public/icons/check-filled.svg';
import exclamationIcon from '../../public/icons/commbank/exclamation.svg';
import infoIcon from '../../public/icons/commbank/info.svg';
import cbaFilterIcon from '../../public/icons/commbank/sliders.svg';
import cbaSortIcon from '../../public/icons/commbank/sort.svg';
import checkIcon from '../../public/icons/racq/check.svg';

type CustomIconProps = {
  partner?: MarketplacePartner | null;
  partnerSize?: number;
  brighteTone?: IconProps['tone'];
  brighteSize?: IconProps['size'];
};

const DEFAULT_PARTNER_ICON_SIZE = 20;

export const CheckIcon = ({
  partner,
  partnerSize = DEFAULT_PARTNER_ICON_SIZE,
  brighteTone = 'primary',
  brighteSize = 'xsmall',
}: CustomIconProps) => {
  switch (partner) {
    case ENTERPRISE_PARTNER_ID.commbank:
    case ENTERPRISE_PARTNER_ID.rewiringAustralia:
      return <img alt="" src={checkFilledIcon} width={partnerSize} height={partnerSize} />;
    case ENTERPRISE_PARTNER_ID.racq:
      return <img alt="" src={checkIcon} width={partnerSize} height={partnerSize} />;
    default:
      return <BrighteCheckCircleIcon size={brighteSize} tone={brighteTone} />;
  }
};

export const AddIcon = ({
  partner,
  partnerSize = DEFAULT_PARTNER_ICON_SIZE,
  brighteTone = 'primary',
  brighteSize = 'xsmall',
}: CustomIconProps) => {
  switch (partner) {
    case ENTERPRISE_PARTNER_ID.commbank:
    case ENTERPRISE_PARTNER_ID.rewiringAustralia:
      return <img alt="" src={addFilledIcon} width={partnerSize} height={partnerSize} />;
    default:
      return <BrightePlusCircleIcon size={brighteSize} tone={brighteTone} />;
  }
};
export const ArrowRightIcon = ({
  partner,
  partnerSize = DEFAULT_PARTNER_ICON_SIZE,
  brighteTone = 'primary',
  brighteSize = 'xsmall',
}: CustomIconProps) => {
  switch (partner) {
    case ENTERPRISE_PARTNER_ID.commbank:
    case ENTERPRISE_PARTNER_ID.rewiringAustralia:
      return <img alt="" src={arrowRightFilledIcon} width={partnerSize} height={partnerSize} />;
    default:
      return <BrighteArrowCircleRightIcon size={brighteSize} tone={brighteTone} />;
  }
};

export const FilterIcon = ({
  partner,
  partnerSize = DEFAULT_PARTNER_ICON_SIZE,
  brighteTone = 'neutral',
  brighteSize = 'small',
}: CustomIconProps) => {
  switch (partner) {
    case ENTERPRISE_PARTNER_ID.commbank:
      return <img alt="" src={cbaFilterIcon} width={partnerSize} height={partnerSize} />;
    default:
      return <AdjustmentsIcon size={brighteSize} tone={brighteTone} />;
  }
};

export const SortIcon = ({
  partner,
  partnerSize = DEFAULT_PARTNER_ICON_SIZE,
  brighteTone = 'neutral',
  brighteSize = 'small',
}: CustomIconProps) => {
  switch (partner) {
    case ENTERPRISE_PARTNER_ID.commbank:
      return <img alt="" src={cbaSortIcon} width={partnerSize} height={partnerSize} />;
    default:
      return <SortAscendingIcon size={brighteSize} tone={brighteTone} />;
  }
};

export const ExclamationIcon = ({
  partner,
  partnerSize = DEFAULT_PARTNER_ICON_SIZE,
  brighteTone = 'neutral',
  brighteSize = 'small',
}: CustomIconProps) => {
  switch (partner) {
    case ENTERPRISE_PARTNER_ID.commbank:
      return <img alt="" src={exclamationIcon} width={partnerSize} height={partnerSize} />;
    default:
      return <ExclamationCircleIcon size={brighteSize} tone={brighteTone} />;
  }
};

export const InfoIcon = ({
  partner,
  partnerSize = DEFAULT_PARTNER_ICON_SIZE,
  brighteTone = 'neutral',
  brighteSize = 'small',
}: CustomIconProps) => {
  switch (partner) {
    case ENTERPRISE_PARTNER_ID.commbank:
      return <img alt="" src={infoIcon} width={partnerSize} height={partnerSize} />;
    default:
      return <InformationCircleIcon size={brighteSize} tone={brighteTone} />;
  }
};
